import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import { AdminActivityReasonComponent } from "../admin-activity-reason/admin-activity-reason.component";
import { AdminActivityStatusComponent } from "../admin-activity-status/admin-activity-status.component";
import { AdminNotificationApproveComponent } from "../admin-notification-approve/admin-notification-approve.component";

@Component({
  selector: "app-admin-activity-log",
  templateUrl: "./admin-activity-log.component.html",
  styleUrls: ["./admin-activity-log.component.css"],
})
export class AdminActivityLogComponent implements OnInit {
  token: any;
  userName: any;
  profilePic: any;
  matDialogref!: MatDialogRef<AdminActivityReasonComponent>;
  matdialogref: MatDialogRef<AdminActivityStatusComponent>;
  matdialogre: MatDialogRef<AdminNotificationApproveComponent>;
  ActivityData: any = [];
  driverIndex: any;
  truckOwnerIndex: any;
  totalIndex: any;
  loading: boolean = false;
  statusAvailable: any = "available";
  statusRejected: any = "rejected";
  notify: boolean = false;
  notifyLoading: boolean = false;
  DriversData: boolean = true;
  activeTab: string = 'all';
  searchTerm: string = '';
  searchTimeout: any;

  constructor(
    private router: Router,
    private services: AdminService,
    private matDialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.getActivity();
    this.GetProfileDetails();
  }

  public GoToDashboard() {
    this.router.navigate(["/admin/dashboard"]);
  }

  onSearch() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.getActivity();
    }, 300);
  }

  getActivity() {
    this.loading = true;
    this.services.activityGet(this.token, this.searchTerm).subscribe(
      (response: any) => {
        this.ActivityData = response.body.data;
        this.driverIndex = this.ActivityData.driver.length;
        this.truckOwnerIndex = this.ActivityData.truckowner.length;
        this.totalIndex = this.driverIndex + this.truckOwnerIndex;
        this.notify = true;
        this.loading = false;
        this.DriversData = false;
      },
      (error) => {
        if (error.error && error.error.message === "No records found") {
          this.notify = true;
          this.DriversData = false;
          this.ActivityData = { driver: [], truckowner: [] };
        }
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  GoToProfile() {
    this.router.navigateByUrl("/adminprofile");
  }
  GoToTasks() { }
  GoToLogout() {
    localStorage.removeItem("adminToken");
    this.router.navigateByUrl("admin/login");
  }

  public GetProfileDetails() {
    this.token = localStorage.getItem("token");
    this.userName = localStorage.getItem("userName");
    this.profilePic = localStorage.getItem("Profile");
  }

  viewDetails(item: any) {
    this.matdialogref = this.matDialog.open(AdminActivityStatusComponent, {
      width: "80vw",
      height: "80vh",
      data: item,
    });
    this.matdialogref.afterClosed().subscribe((x) => {
      this.getActivity();
    });
  }

  activityStatus(item: any, status: any) {
    if (status == "available") {
      this.matdialogre = this.matDialog.open(
        AdminNotificationApproveComponent,
        {
          width: "auto",
          data: item,
        }
      );
      this.matdialogre.afterClosed().subscribe((x) => {
        if (x.status == "success") {
          this.getActivity();
        }
      });
    }
    if (status == "rejected") {
      this.matDialogref = this.matDialog.open(AdminActivityReasonComponent, {
        width: "40vw",

        data: {
          id: item.loginInfo[0].ref_id,
          status: item,
          user_data: item.loginInfo[0].user_type,
          userStatus: status,
        },
      });
      this.matDialogref.afterClosed().subscribe((x) => {
        if (x.status == "success") {
          this.getActivity();
        }
      });
    }
  }
}
